module.exports = __webpack_public_path__ + "img/宣传_154.d11c68d5.jpg";